import React, { useEffect, useRef, useState} from 'react';
import ReactDOM from "react-dom";
import '../css/CultivateHR.css';
import Text from '../../../common/Text.js'; 
import learn from '../img/sotec_icon_learn.png';
import employee from '../img/sotec_icon_employee.png';
import manager from '../img/sotec_icon_manager.png';
import learning from '../img/sotec_icon_learning.png';

function CultivateHR() {
     return ( 
        <div class = 'groupa'>

        <div className='VisionBody_ㅣ'>
            <div className='VisionBody122'>
                <Text variant='titlename' className='TitleA'>인재상</Text>
            </div>  

            <div className='VisionBody2'>
                        <Text variant='px32w700B' className='VisionText1'>인재상 명칭</Text>
                        <div className="VisionContent1">
                            <div className='VisionContent2'>
                                <Text variant='px28w400'>바다를 담는 그릇, &nbsp;</Text>
                                <Text variant='px28w600'>S.O.T.E.C </Text>
                                <Text variant='px28w400'>  형 인재 &nbsp;</Text>
                            </div>

                            {/* <p style={{fontFamily:'Pretendard', fontSize:'18px', fontWeight:'400',color:'#0C4DA2',lineHeight:'33px',margin:'0px'}}>
                                * 쟁반(錚盤) 운두가 얕고 동글거나 네모난, 넓고 큰 그릇</p> */}
                        </div>
                    </div>

           <div className='comp_groups'>
            <div className='comp_S_G_C_ㅣ'>
               <Text variant='px24w600' >S (Solution) : 능동적 해결사</Text>
               <div >
                   <Text variant='px20w500' className='comp_S_C'>어떤 새로운 문제나 변화에 직면해도 피하지 않고 능동적으로 최적의 해결책을 찾아내는 인재</Text>
               </div>
             </div>

             
            <div className='comp_S_G_C_ㅣ'>
               <Text variant='px24w600' >O (Outstanding) : 품질 최우선주의자</Text>
               <div >
                   <Text variant='px20w500' className='comp_S_C'>고객의 니즈를 명확히 이해하고, 기대를 넘어서는 우수한 품질을 구현하는 인재</Text>
               </div>
             </div>

             
            <div className='comp_S_G_C_ㅣ'>
               <Text variant='px24w600'>T (Trust) : 신뢰 구축가</Text>
               <div >
                   <Text variant='px20w500' className='comp_S_C'>최고의 품질과 기술력을 바탕으로 고객 및 동료와 깊은 신뢰 관계를 형성하는 인재</Text>
               </div>
             </div>

             
            <div className='comp_S_G_C_ㅣ'>
               <Text variant='px24w600' >E (Expertise) : 지속적 성장가</Text>
               <div >
                   <Text variant='px20w500' className='comp_S_C'>안주하지 않고 지속적인 학습과 자기개발을 통해 분야 최고의 전문성을 확보하는 인재</Text>
               </div>
             </div>

             
            <div className='comp_S_G_C_ㅣ'>
               <Text variant='px24w600' >C (Challenge) : 끊임없는 도전가</Text>
               <div >
                   <Text variant='px20w500' className='comp_S_C'>한계를 두지 않는 넓은 포용력(그릇)을 바탕으로, 성장과 성취를 향해 담대하게 도전하는 인재</Text>
               </div>
             </div>

             </div>
            </div>



            <div className='VisionBody1'>
                <Text variant='titlename' className='TitleA'>인재육성</Text>
            </div>  

            <div className='contentA' >
                <Text variant='px32w700B' id='cultivateHR_Title'>쏘테크는 임직원을 소중한 가치로 여기며</Text>
                <Text variant='px32w700B' id='cultivateHR_Title'>개인의 성장을 돕고 능력을 최대한 발휘할 수 있도록</Text>
                <Text variant='px32w700B' id='cultivateHR_Title'>체계적인 교육을 제공하고 있습니다. </Text>
            </div>
        
            <div className='comp_U'>
               
                <div className='comp_M'>
                    <div  className='comp_S_box'>
                        <div className='comp_S_learn'>
                            <img className="imgs"  src={learn} ></img>
                            <div className='comp_S_G'>
                                <Text variant='px24w600' className='comp_S_T'>입문 교육</Text>
                                <div className='comp_S_G_C'>
                                    <Text variant='px20w500' className='comp_S_C'>- 신규 임직원의 점진적 성장을 위한 지원</Text>
                                    <Text variant='px20w500' className='comp_S_C'>- 조선·해양 전문가 마음가짐 함양</Text>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* </div> */}

                    <div className='comp_S_box'>
                        <div className='comp_S_employee'>
                            <img className="imgs"  src={employee} ></img>
                            <div className='comp_S_G'>
                                <Text variant='px24w600' className='comp_S_T'>임직원 양성 교육</Text>
                                <div className='comp_S_G_C'>
                                    <Text variant='px20w500' className='comp_S_C'>- 이론과 실무능력 향상을 위한 일학습병행제,</Text>
                                    <Text variant='px20w500' className='comp_S_CB'>  멘토링, 코칭 제도 등</Text>
                                </div>
                            </div>
                        </div>                    
                    </div>
                    <div className='comp_S_box'>
                        <div className='comp_S_manager'>
                            <img className="imgs"  src={manager} ></img>
                            <div className='comp_S_G'>
                                <Text variant='px24w600' className='comp_S_T'>관리자 교육</Text>
                                <div className='comp_S_G_C'>
                                    <Text variant='px20w500' className='comp_S_C'>- 조직의 성장과 발전을 이끌어갈 리더 육성</Text>
                                    <Text variant='px20w500' className='comp_S_C'>- 윤리적이고 책임감 있는 경영 실천</Text>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='comp_S_box'>
                        <div className='comp_S_learning'>
                            <img className="imgs"  src={learning} ></img>
                            <div className='comp_S_G'>
                                <Text variant='px24w600' className='comp_S_T'>지속적인 학습</Text>
                                <div className='comp_S_G_C'>
                                    <Text variant='px20w500' className='comp_S_C'>- 자기주도 학습 문화 구축</Text>
                                    <Text variant='px20w500' className='comp_S_C'>- 사외 직무관련 교육 지원 및 기획</Text>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                                                                         
                </div>

                <div className='comp_M_B'>

                </div>


            </div>

         </div>
     );
 }

 export default CultivateHR;
